import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["tenantSettings", "globalSelectedShop", "featureToggles"]),
		isExtraAddOnsShown() {
			return this.filteredProducts ? this.addonsLimit < this.filteredProducts.length : this.addonsLimit < this.group.products.length;
		},
		addonsLimit() {
			const arrayOfProducts = this.filteredProducts ? this.filteredProducts : this.group.products;
			const noThanksIndex = arrayOfProducts.findIndex((p) => (p.options && p.options.isNoThanks) || p.id === "999999");
			if(noThanksIndex > -1 && noThanksIndex < this.tenantSettings.additionsFoldingThreshold) {
				return this.tenantSettings.additionsFoldingThreshold + 1 || 5;
			}
			return this.tenantSettings.additionsFoldingThreshold || 4;
		},
		newAddonsFlow() {
			return this.featureToggles.newAddonsDesignAndFlow && this.globalSelectedShop.shopOptions.newAddonsDesign;
		}
	}
};
